// Shared display helpers for schema.org JSON-LD blobs (video settings modal
// + product settings modal Agentic tabs).

const TOKEN_COLORS: Record<string, string> = {
    key: "#A0662E",
    str: "#1C7A5A",
    num: "#2D6CB5",
    bool: "#9B59B6",
    null: "#9B59B6"
};

export const escapeHtml = (s: string) =>
    s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export const highlightJson = (json: string) =>
    escapeHtml(json).replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
        (m) => {
            let cls = "num";
            if (/^"/.test(m)) cls = /:$/.test(m) ? "key" : "str";
            else if (/true|false/.test(m)) cls = "bool";
            else if (/null/.test(m)) cls = "null";
            return `<span style="color:${TOKEN_COLORS[cls]}">${m}</span>`;
        }
    );

// Builds the copy-paste HTML meta tags from an object carrying name/title,
// description, and keywords — works for both the jsonld endpoint's `meta`
// and a JSON-LD VideoObject itself.
export const formatMetaTags = (meta: any) => {
    if (!meta) return "";
    const lines: string[] = [];
    if (meta.name || meta.title) {
        lines.push(`<title>${meta.name || meta.title}</title>`);
    }
    if (meta.description) {
        lines.push(`<meta name="description" content="${meta.description}" />`);
    }
    if (meta.keywords) {
        const keywordsString = Array.isArray(meta.keywords) ? meta.keywords.join(", ") : meta.keywords;
        lines.push(`<meta name="keywords" content="${keywordsString}" />`);
    }
    return lines.join("\n");
};
